import * as React from 'react';
import logoDeluxe from './DumpertDeluxe.svg';
import styles from './DeluxeHeader.css';
import { DeluxeActionButton } from './';

export const DeluxeHeader = () => {
  return (
    <>
      <header>
        <section>
          <img
          // eslint-disable-next-line
          src={logoDeluxe}
            alt="Dumpert Deluxe"
            className='logo'
          />
          <DeluxeActionButton back />
          <DeluxeActionButton dumpert />  
        </section>
      </header>
      <div className={styles.close}>
        <DeluxeActionButton exit />
      </div>
    </>
  );
};